import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import React, { useEffect, useMemo } from "react";
import "./pointCorrespondance.scss";
import CloseIcon from "@mui/icons-material/Close";
import { correspondance_config } from "./correspondanceConfig";
import { ReactComponent as GapSvg } from "./SVG/correspondanceImg.svg";
import { ReactComponent as AlertSvg } from "./SVG/ALERT_SVG_ICON.svg";
import NotificationBellWAV from "../../../assets/audio/alert_bell.wav";
import moment from "moment";
function areEqual(prevProps, nextProps) {
  // const prevTsDetection = prevProps?.dataPacket?.DETECTION?.DATE?.[0]?.ts;
  // const nextTsDetection = nextProps.dataPacket.DETECTION?.DATE?.[0]?.ts;

  // const prevTsOperation = prevProps?.dataPacket?.OPERATION?.DATE?.[0]?.ts;
  // const nextTsOperation = nextProps.dataPacket.OPERATION?.DATE?.[0]?.ts;

  // const prevTsGap = prevProps?.dataPacket?.GAP?.DATE?.[0]?.ts;
  // const nextTsGap = nextProps?.dataPacket?.GAP?.DATE?.[0]?.ts;
  // console.log('render update', prevTsDetection === nextTsDetection || prevTsOperation === nextTsOperation || prevTsGap === nextTsGap)
  // return prevTsDetection === nextTsDetection || prevTsOperation === nextTsOperation || prevTsGap === nextTsGap;
  return true;
}

const isValidNum = (num) => {
  let isNum = false;
  if (num || num == 0) {
    const _number = Number(num);
    return !isNaN(_number);
  }
  return isNum;
};

// import './PointCorrespondancePopup.scss'
const ObjectViewer = ({ object }) => {
  return (
    <div className="object-viewer">
      {Object.entries(object).map(([key, val]) => {
        return (
          <div className="object-viewer-row">
            {/* {`${key} : ${val}`} */}
            <div className="key">{key} :</div>
            <div className="val">{val}</div>
          </div>
        );
      })}
    </div>
  );
};

const getDataForObjectDataViewer = (data, config) => {
  let _data = {};
  Object.entries(config).forEach(([sectionType, sectionConfig]) => {
    _data[sectionType] = {};
    sectionConfig.forEach((keyInfo) => {
      const { key, label, packetType, unit } = keyInfo;
      let rawVal = data?.[packetType]?.[key];
      if (sectionType === "genral_info") {
        rawVal = rawVal || data?.["DETECTION"]?.[key] || data?.["GAP"]?.[key];
      }
      if (unit && unit === "TIMESTAMP" && isValidNum(data?.[packetType]?.lastActivityTime)) {
        rawVal = moment(Number(data?.[packetType]?.lastActivityTime)).format("DD-MM-YYYY HH:mm:ss");
      } else if (unit && !unit.startsWith("m")) {
        rawVal = (Number(rawVal) / 1000) % 1 !== 0 ? (Number(rawVal) / 1000).toFixed(2) : Number(rawVal) / 1000;

        if ((rawVal || isValidNum(rawVal)) && rawVal !== "NaN") {
          rawVal = `${rawVal} ${unit === "MM" ? unit.toLowerCase() : unit}`;
        }
      }
      _data[sectionType][label] = rawVal && rawVal !== "NaN" ? rawVal : "-";
    });
  });

  return _data;
};

const getGapDataDirection = (gapData) => {
  const S1 = gapData?.["S1GAP"];
  const S2 = gapData?.["S2GAP"];
  const S3 = gapData?.["S3GAP"];
  const S4 = gapData?.["S4GAP"];
  if (isValidNum(S1) && isValidNum(S2) && isValidNum(S3) && isValidNum(S4)) {
    if (Number(S1) / 1000 < 3 && Number(S2) / 1000 < 3 && Number(S3) / 1000 > 7 && Number(S4) / 1000 > 7) {
      return "dir_normal";
    } else if (Number(S1) / 1000 > 7 && Number(S2) / 1000 > 7 && Number(S3) / 1000 < 3 && Number(S4) / 1000 < 3) {
      return "dir_reverse";
    } else {
      return "dir_error";
    }
  } else {
    return "dir_unknown";
  }
};
const getDetectionDataDirection = (detectionData) => {
  const NWKR = detectionData?.["NWKR"] ?? null;
  const RWKR = detectionData?.["RWKR"] ?? null;

  if (isValidNum(NWKR) && isValidNum(RWKR)) {
    let nwkr_val = Number(NWKR) / 1000;
    let rwkr_val = Number(RWKR) / 1000;
    if (nwkr_val > 18 && rwkr_val < 18) {
      return "dir_normal";
    } else if (nwkr_val < 18 && rwkr_val > 18) {
      return "dir_reverse";
    } else {
      return "dir_error";
    }
  } else {
    return "dir_unknown";
  }
};
const audioWAV = new Audio(NotificationBellWAV);
const getCorrespondenceErrror = (direction_gap, direction_detection, gapData) => {
  let err_correspondence =
    (direction_gap === "dir_normal" && direction_detection === "dir_reverse") ||
    (direction_gap === "dir_reverse" && direction_detection === "dir_normal");
  let gap_err_1 = null;
  let gap_err_2 = null;
  const S1 = gapData?.["S1GAP"];
  const S2 = gapData?.["S2GAP"];
  const S3 = gapData?.["S3GAP"];
  const S4 = gapData?.["S4GAP"];

  if (isValidNum(S1) && isValidNum(S2) && isValidNum(S3) && isValidNum(S4)) {
    let s1_num = Number(S1) / 1000;
    let s2_num = Number(S2) / 1000;
    let s3_num = Number(S3) / 1000;
    let s4_num = Number(S4) / 1000;
    gap_err_1 = s1_num > 3 && s1_num < 7 && s2_num > 3 && s2_num < 7 && s3_num > 7 && s4_num > 7;
    gap_err_2 = s3_num > 3 && s3_num < 7 && s4_num > 3 && s4_num < 7 && s1_num > 7 && s2_num > 7;
  }

  let final_alert = err_correspondence || gap_err_1 || gap_err_2;

  if (final_alert) {
    audioWAV.loop = true;
    audioWAV.play();
    return true;
  } else {
    audioWAV.loop = false;
    audioWAV.pause();
    // audioWAV.currentTime = 0;

    return false;
  }
};

const HistoryPointCorrespondencePopup = ({ open, dataPacket, onClose }) => {
  console.log("dataPacket", dataPacket);
  const {
    genral_info = {},
    information = {},
    field_status = {},
    relay_room_status = {},
  } = getDataForObjectDataViewer(dataPacket, correspondance_config);
  const direction_Gap = getGapDataDirection(dataPacket?.GAP ?? {});
  const direction_detection = getDetectionDataDirection(dataPacket?.DETECTION ?? {});
  const correspondanceAlert = getCorrespondenceErrror(direction_Gap, direction_detection, dataPacket?.GAP);

  useEffect(() => {
    return () => {
      audioWAV.loop = false;
      audioWAV.pause();
    };
  }, []);

  return (
    <Dialog
      open={open}
      aria-labelledby="responsive-dialog-title"
      // TransitionComponent={Transition}
      fullWidth={true}
      maxWidth={"lg"}
    >
      <DialogTitle id="responsive-dialog-title" className="flex">
        {`Point Machine Correspondance Status`}
        <CloseIcon className="pointer" sx={{ ml: "auto" }} onClick={onClose} />
      </DialogTitle>
      <DialogContent>
        <div className="point-correspondace-container">
          <div className="correspondanceCard">
            <div className="operation-info-container card-child-container">
              <div className="genralInfo infoCard">
                <div className="label">GENERAL INFO</div>
                <ObjectViewer object={genral_info} />
              </div>
              {Object.keys(dataPacket?.OPERATION ?? {}).length > 0 && (
                <div className="'dataValues infoCard">
                  <div className="label">Information</div>
                  <ObjectViewer object={information} />
                </div>
              )}
            </div>
            <div className="field-info-container card-child-container">
              <div className="card-child-label">FIELD STATUS</div>
              <div className="fieldInfo-child-container">
                <div className="data-child">
                  <ObjectViewer object={field_status} />
                </div>
                <div className="direction-child">
                  <div
                    className={`normalBox directionBox ${direction_Gap} ${
                      direction_Gap === "dir_normal" ? "status_green" : ""
                    } `}
                  >
                    NORMAL
                  </div>
                  <div className="svgImg">{<GapSvg />}</div>
                  <div
                    className={`reverseBox directionBox ${direction_Gap} ${
                      direction_Gap === "dir_reverse" ? "status_green" : ""
                    }`}
                  >
                    REVERSE
                  </div>
                </div>
              </div>
            </div>
            <div className="relay-room-status-container card-child-container">
              <div className="card-child-label">RELAY ROOM STATUS</div>
              <div className="relayInfo-child-container">
                <div className="data-child">
                  <ObjectViewer object={relay_room_status} />
                </div>
                <div className="direction-child">
                  <div
                    className={`normalBox directionBox ${direction_detection} ${
                      direction_detection === "dir_normal" ? "status_green" : ""
                    } `}
                  >
                    NORMAL
                  </div>
                  <div
                    className={`reverseBox directionBox ${direction_detection} ${
                      direction_detection === "dir_reverse" ? "status_green" : ""
                    }`}
                  >
                    REVERSE
                  </div>
                </div>
              </div>
            </div>
          </div>
          <AlertSvg className={`alert-icon ${correspondanceAlert ? "correspondaceError" : ""}`} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default HistoryPointCorrespondencePopup;
